import { render, staticRenderFns } from "./AdminSettingsAvatar.vue?vue&type=template&id=343b8876&scoped=true"
import script from "./AdminSettingsAvatar.vue?vue&type=script&lang=js"
export * from "./AdminSettingsAvatar.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsAvatar.vue?vue&type=style&index=0&id=343b8876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343b8876",
  null
  
)

export default component.exports